/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsPopup = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsPopup = $.extend(this, window.PXUTheme.getSectionData($section));
    if (window.Shopify && window.Shopify.designMode) return;

    // Blaq — the letter promises "sent rarely, read slowly", so it does not
    // interrupt a first read. Count pageviews for this visit and hold until the
    // second. If storage is unavailable (private mode), fail open to the old
    // behaviour rather than silently killing the only email capture.
    var blaqViews = 2;
    try {
      blaqViews = (parseInt(sessionStorage.getItem('blaq_pv'), 10) || 0) + 1;
      sessionStorage.setItem('blaq_pv', blaqViews);
    } catch (e) { blaqViews = 2; }
    if (blaqViews < 2) return false;

    const cookieValue = Cookies.get('popup');
    const cookieEnabled = this.popup_days_to_hide != 0 ? true : false;

    if (cookieEnabled && cookieValue == 'opened') {
      return false;
    } else {
      setTimeout(() => {
        this.open();
        if (cookieEnabled) {
          Cookies.set('popup', 'opened', { expires: parseInt(this.popup_days_to_hide) });
        }
      }, this.popup_delay * 1000);
    }

  },
  open: function() {
    $.fancybox.open({
      src: '[data-popup]',
      type: 'inline',
      opts: {
        baseClass: 'popup-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        },
        beforeShow: () => {
          // Remove previous slides (fix for theme editor)
          $('.popup-modal .fancybox-slide').empty();
        },
        afterShow: () => {
          // After content is loaded, attach event listener for custom close icon
          $(document).on('touchstart click', '.popup__close', () => {
            this.close();
          });
        },
        beforeClose: () => {
          // Prevent duplicate triggers for close icon click
          $('.popup__close').off();
        }
      }
    });
  },
  close: function() {
    $.fancybox.close($('[data-popup]'));
  },
  showThemeEditorState() {
    $('.popup-section').addClass('is-fixed-top'); // Prevent scroll to bottom
    this.open();
  },
  hideThemeEditorState() {
    $('.popup-section').removeClass('is-fixed-top');
    this.close();
  },
  unload: function ($section) {
    $.fancybox.destroy();
    $('.popup-modal .fancybox-slide').empty();
    $('.popup__close').off();
  }
}

/******/ })()
;